import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { obtenerReporteProductos } from '../../services/productosApi';
import { hoyChile, primerDiaMesChile } from '../../services/utils';

const ReporteProductos = () => {
    const [reporteData, setReporteData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    
    const [fechas, setFechas] = useState({
        inicio: primerDiaMesChile(),
        fin: hoyChile()
    });

    // 2. LÓGICA DE CARGA
    const cargarReporte = async () => {
        setIsLoading(true);
        try {
            const data = await obtenerReporteProductos(fechas.inicio, fechas.fin);
            setReporteData(data || []);
            if (data.length === 0) {
                toast.info("No hay ventas registradas en este rango.");
            }
        } catch (error) {
            console.error("Error al cargar reporte:", error);
            toast.error("Error al conectar con el servidor.");
        } finally {
            setIsLoading(false);
        }
    };

    // Cargar al montar el componente
    useEffect(() => {
        cargarReporte();
    }, []);

    // 3. CÁLCULOS PARA TARJETAS (KPIs)
    const totalUnidades = reporteData.reduce((acc, curr) => acc + curr.vendidos, 0);
    const totalPesos = reporteData.reduce((acc, curr) => acc + curr.recaudado, 0);
    const productoEstrella = reporteData.length > 0 ? reporteData[0].nombre : "---";

    return (
        <div className="bg-light min-vh-100 py-5 px-3">
            <ToastContainer position="bottom-center" autoClose={2000} hideProgressBar />
            
            <div className="container" style={{ maxWidth: '1100px' }}>
                
                {/* CABECERA */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-5">
                    <div>
                        <h1 className="h2 font-weight-bold text-dark mb-1">Productos más vendidos</h1>
                        <p className="text-muted m-0">Análisis de rendimiento por rango de fechas.</p>
                    </div>
                    <div className="mt-3 mt-md-0">
                        <button className="btn btn-white border rounded-pill shadow-sm px-4 font-weight-bold mr-2" onClick={() => window.print()}>
                            <i className="fas fa-print mr-2"></i> Imprimir
                        </button>
                    </div>
                </div>

                {/* FILTROS DE FECHA */}
                <div className="card border-0 shadow-sm rounded-xl p-4 mb-4">
                    <div className="row align-items-end">
                        <div className="col-md-4 mb-3 mb-md-0">
                            <label className="text-uppercase small font-weight-bold text-muted mb-2 d-block">Fecha Inicio</label>
                            <input 
                                type="date" className="form-control border-light bg-light rounded-pill" 
                                value={fechas.inicio} 
                                onChange={(e) => setFechas({...fechas, inicio: e.target.value})}
                            />
                        </div>
                        <div className="col-md-4 mb-3 mb-md-0">
                            <label className="text-uppercase small font-weight-bold text-muted mb-2 d-block">Fecha Fin</label>
                            <input 
                                type="date" className="form-control border-light bg-light rounded-pill" 
                                value={fechas.fin} 
                                onChange={(e) => setFechas({...fechas, fin: e.target.value})}
                            />
                        </div>
                        <div className="col-md-4">
                            <button 
                                className="btn btn-primary btn-block rounded-pill font-weight-bold shadow-sm py-2"
                                onClick={cargarReporte}
                                disabled={isLoading}
                            >
                                {isLoading ? <span className="spinner-border spinner-border-sm"></span> : "Actualizar Reporte"}
                            </button>
                        </div>
                    </div>
                </div>

                {/* TARJETAS KPI */}
                <div className="row mb-4">
                    <div className="col-md-4 mb-3">
                        <div className="card border-0 shadow-sm rounded-xl p-4 text-center h-100">
                            <div className="icon-circle bg-soft-info mb-3 mx-auto">
                                <i className="fas fa-shopping-basket text-info"></i>
                            </div>
                            <h6 className="text-muted small text-uppercase font-weight-bold">Uni. Vendidas</h6>
                            <h3 className="font-weight-bold mb-0">{totalUnidades.toLocaleString()}</h3>
                        </div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <div className="card border-0 shadow-sm rounded-xl p-4 text-center h-100">
                            <div className="icon-circle bg-soft-success mb-3 mx-auto">
                                <i className="fas fa-dollar-sign text-success"></i>
                            </div>
                            <h6 className="text-muted small text-uppercase font-weight-bold">Total Ingresos</h6>
                            <h3 className="font-weight-bold mb-0">${totalPesos.toLocaleString('es-CL')}</h3>
                        </div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <div className="card border-0 shadow-sm rounded-xl p-4 text-center h-100">
                            <div className="icon-circle bg-soft-warning mb-3 mx-auto">
                                <i className="fas fa-crown text-warning"></i>
                            </div>
                            <h6 className="text-muted small text-uppercase font-weight-bold">Top Ventas</h6>
                            <h3 className="font-weight-bold mb-0 text-truncate px-2">{productoEstrella}</h3>
                        </div>
                    </div>
                </div>

                {/* TABLA RANKING */}
                <div className="card border-0 shadow-sm rounded-xl overflow-hidden mb-5">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th className="border-0 px-4 py-3 text-muted small text-uppercase" style={{width: '80px'}}>Pos.</th>
                                        <th className="border-0 py-3 text-muted small text-uppercase">Producto</th>
                                        <th className="border-0 py-3 text-muted small text-uppercase text-center">Unidades</th>
                                        <th className="border-0 py-3 text-muted small text-uppercase">Venta Total</th>
                                        <th className="border-0 px-4 py-3 text-center text-muted small text-uppercase">Popularidad</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <tr><td colSpan="5" className="text-center py-5 text-muted">Procesando datos...</td></tr>
                                    ) : reporteData.map((item, index) => (
                                        <tr key={item.id}>
                                            <td className="px-4 py-3 font-weight-bold text-muted">
                                                {index === 0 ? <span className="h4 m-0">🥇</span> : `#${index + 1}`}
                                            </td>
                                            <td className="py-3">
                                                <span className="font-weight-bold text-dark d-block">{item.nombre}</span>
                                                <small className="text-muted">ID: {item.id}</small>
                                            </td>
                                            <td className="py-3 text-center">
                                                <span className="badge badge-soft-primary px-3 py-2 rounded-pill font-weight-bold">
                                                    {item.vendidos}
                                                </span>
                                            </td>
                                            <td className="py-3 font-weight-bold text-dark">
                                                ${item.recaudado.toLocaleString('es-CL')}
                                            </td>
                                            <td className="px-4 py-3">
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <div className="progress rounded-pill w-100" style={{ height: '8px', maxWidth: '120px' }}>
                                                        <div 
                                                            className={`progress-bar rounded-pill ${index === 0 ? 'bg-warning' : 'bg-primary'}`} 
                                                            style={{ width: `${(item.vendidos / reporteData[0].vendidos) * 100}%` }}
                                                        ></div>
                                                    </div>
                                                    <small className="ml-2 font-weight-bold text-muted">
                                                        {Math.round((item.vendidos / totalUnidades) * 100)}%
                                                    </small>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {!isLoading && reporteData.length === 0 && (
                                <div className="text-center py-5">
                                    <i className="fas fa-chart-bar fa-3x text-light mb-3"></i>
                                    <p className="text-muted">No se encontraron datos para este periodo.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* ESTILOS INTERNOS */}
            <style jsx>{`
                .rounded-xl { border-radius: 1.25rem !important; }
                .bg-soft-info { background-color: #e3fafc; }
                .bg-soft-success { background-color: #e6fcf5; }
                .bg-soft-warning { background-color: #fff9db; }
                .badge-soft-primary { background-color: #e7f1ff; color: #007bff; }
                .icon-circle {
                    width: 55px; height: 55px; border-radius: 50%;
                    display: flex; align-items: center; justify-content: center;
                    font-size: 1.4rem;
                }
                .table-hover tbody tr:hover { background-color: #fbfbfb; }
                .progress { background-color: #f1f3f5; box-shadow: inset 0 1px 2px rgba(0,0,0,0.05); }
            `}</style>
        </div>
    );
};

export default ReporteProductos;